import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const SpendControllerPageWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;
export const ContentDiv = styled.div`
	height: 100%;
	overflow: auto;
`;
export const ValueWrapper = styled.div`
	display: inline-flex;
	box-sizing: content-box;
	width: 177px;
	margin-bottom: 19px;
	padding-right: 32px;
`;
export const Div = styled.div`
	& > * {
		display: inline-block;
		font-size: 15px;
		border-radius: 0;
		-webkit-appearance: none;
		height: 15px;
	}
`;
export const TopRibbon = styled.div`
	border-bottom: 1px dashed ${colors.grey300};
	margin: 0 5px 5px 5px;
	display: flex;
	justify-content: end;
`;
export const Input = styled.input`
	border: none;
	outline: none;
	text-align: center;
`;
export const SelectWrapper = styled.div`
	width: 150px;

	label {
		display: none;
	}

	& span {
		line-height: 24px;
		border-color: ${colors.grey4};
	}
`;

export const SectionForm = styled.div`
	display: flex;
	flex-wrap: wrap;

	${SelectWrapper} {
		label {
			display: none;
		}
	}

	${ValueWrapper} {
		width: 120px;
		padding-right: 16px;
	}
`;
export const ButtonWrapper = styled.div`
	display: flex;
`;
export const Button = styled.button`
	flex: 1;
	padding: 10px;
	border: none;
	outline: none;
	font-size: 16px;
	background-color: transparent;
	cursor: pointer;
	position: relative;
	&::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: ${props => (props.isSelected ? '1px' : '0')};
		background-color: green;
		transition: height 0.3s;
	}
	&:hover::after {
		height: 1.5px;
	}
`;
